<template>
  <div :class="embedded ? 'embeddedPage' : 'page'">
    <home-header v-if="!embedded" activeIndex="1" pageTitle="报到意向确认" />
    <div :class="embedded ? 'embeddedWrap' : 'pageWrap'">
      <div class="card">
        <div class="title">报到意向确认</div>
        <div class="infoRow">
          <span class="label">当前状态</span>
          <span class="value">{{ intentText(currentIntent) }}</span>
        </div>
        <div class="infoRow">
          <span class="label">更新时间</span>
          <span class="value">{{ formatTime(intentTime) }}</span>
        </div>
        <div class="infoRow">
          <span class="label">可修改时间</span>
          <span class="value">{{ formatTime(windowStart) }} ~ {{ formatTime(windowEnd) }}</span>
        </div>

        <div class="formItem">
          <div class="formLabel">报到意向</div>
          <a-radio-group v-model="form.intent" :disabled="!canEdit">
            <a-radio :value="1">确认报到</a-radio>
            <a-radio :value="2">放弃报到</a-radio>
          </a-radio-group>
        </div>

        <div class="formItem">
          <div class="formLabel">意向说明</div>
          <a-textarea
            v-model="form.intentRemark"
            :maxLength="100"
            :disabled="!canEdit"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            placeholder="选择放弃报到时必填，最多100字"
          />
          <div class="count">{{ (form.intentRemark || '').length }}/100</div>
        </div>

        <div class="warning" v-if="!canEdit">当前不在报名确认时间范围内，暂不可修改。</div>

        <div class="buttons">
          <a-button v-if="!embedded" @click="goBack">返回</a-button>
          <a-button
            type="primary"
            :style="{ marginLeft: embedded ? '0' : '12px' }"
            :loading="submitLoading"
            :disabled="!canEdit"
            @click="submit"
          >
            提交
          </a-button>
        </div>
      </div>
    </div>
    <Footer v-if="!embedded" />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader'
import Footer from '@/components/footer'
import { getArrivalIntent, saveArrivalIntent } from '@/api/form'

export default {
  name: 'ArrivalIntent',
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      currentIntent: 0,
      intentTime: null,
      windowStart: null,
      windowEnd: null,
      canEdit: false,
      form: {
        intent: undefined,
        intentRemark: '',
      },
    }
  },
  methods: {
    getSid() {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      return userInfo && userInfo.sid ? userInfo.sid : null
    },
    goBack() {
      if (this.embedded) {
        return
      }
      this.$router.go(-1)
    },
    intentText(intent) {
      if (Number(intent) === 1) {
        return '确认报到'
      }
      if (Number(intent) === 2) {
        return '放弃报到'
      }
      return '未确认'
    },
    formatTime(value) {
      if (!value) {
        return '--'
      }
      const date = new Date(Number(value))
      if (Number.isNaN(date.getTime())) {
        return '--'
      }
      const pad = (num) => (num < 10 ? '0' + num : '' + num)
      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
      )
    },
    loadData() {
      const sid = this.getSid()
      const params = {}
      if (sid) {
        params.sId = sid
      }
      this.loading = true
      getArrivalIntent(params)
        .then((res) => {
          this.loading = false
          if (!res || res.code !== 0) {
            this.$message.error((res && res.msg) || '查询失败')
            return
          }
          const data = res.data || {}
          this.currentIntent = data.intent ? Number(data.intent) : 0
          this.form.intent = data.intent ? Number(data.intent) : undefined
          this.form.intentRemark = data.intentRemark || ''
          this.intentTime = data.intentTime || null
          this.windowStart = data.windowStart || null
          this.windowEnd = data.windowEnd || null
          this.canEdit = !!data.canEdit
        })
        .catch(() => {
          this.loading = false
        })
    },
    submit() {
      if (!this.form.intent) {
        this.$message.warning('请选择报到意向')
        return
      }
      const remark = (this.form.intentRemark || '').trim()
      if (this.form.intent === 2 && !remark) {
        this.$message.warning('选择放弃报到时，意向说明不能为空')
        return
      }
      if (remark.length > 100) {
        this.$message.warning('意向说明不能超过100字')
        return
      }
      const sid = this.getSid()
      const params = {
        intent: this.form.intent,
        intentRemark: remark,
      }
      if (sid) {
        params.sId = sid
      }
      this.submitLoading = true
      saveArrivalIntent(params)
        .then((res) => {
          this.submitLoading = false
          if (res && res.code === 0) {
            this.$message.success(res.msg || '提交成功')
            this.loadData()
          } else {
            this.$message.error((res && res.msg) || '提交失败')
          }
        })
        .catch(() => {
          this.submitLoading = false
        })
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.embeddedPage {
  background-color: transparent;
}
.pageWrap {
  width: 1200px;
  margin: 20px auto;
}
.embeddedWrap {
  width: 100%;
}
.card {
  background: #fff;
  border-radius: 6px;
  padding: 24px 30px 28px;
  min-height: 420px;
}
.embeddedWrap .card {
  min-height: 448px;
}
.title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}
.infoRow {
  display: flex;
  margin-bottom: 12px;
}
.label {
  width: 110px;
  color: #666;
}
.value {
  color: #333;
}
.formItem {
  margin-top: 20px;
}
.formLabel {
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
}
.count {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 6px;
}
.warning {
  margin-top: 12px;
  color: #f5222d;
}
.buttons {
  margin-top: 28px;
}
</style>
